import React from 'react';
import Auth from '../general/auth.js';
import Test from './test.js';
import TestResult from './testresults.js';
import TestInter from './interactivetests.js'

export default class Course extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            loaded: false,
            attempt: {},
            vidFound: false,
            videoPath: "",
            scormWatched: false,
            coursePath: ""
        }
        this.phaseFinished = this.phaseFinished.bind(this);
        this.renderMedia = this.renderMedia.bind(this);
        this.getMedia = this.getMedia.bind(this);
        this.getAttempt = this.getAttempt.bind(this);
        this.startTest = this.startTest.bind(this);
        this.final = this.final.bind(this);
        this.getIframePath = this.getIframePath.bind(this);
    }
    componentDidMount()
    {
        this.checkAuth();
        this.getIframePath();
    }
    checkAuth()
    {

        new Auth().checkAuth(this.props.api, (result) => {
            this.setState({authenticated: true});
            this.getAttempt();
        }, (err) => {
            console.dir(err);
        });
    }
    getAttempt()
    {
        this.setState({loaded: false});
        var attemptID = null;
        if (localStorage.getItem("attemptID") !== null)
        {
            attemptID = localStorage.getItem("attemptID");
        }
        this.props.api.send({
            controller: "Attempt",
            action: "GetAttempt",
            method: "post",
            body: JSON.stringify({courseID: this.props.courseID, attemptID: attemptID}),
            success: (result) => {
                if (result.success)
                {
                    this.setState({
                        loaded: true, 
                        attempt: result.attempt
                    }, () => {
                            localStorage.setItem("attemptID", result.attempt.attemptID);
                        });
                    this.getMedia();
                }
                else
                {
                    this.setState({loaded: true});
                }   
            },
            error: (err) => {
                this.setState({loaded: true});
            }
        })
    }
    getIframePath() {

        this.setState({ loaded: false });
        this.props.api.send({
            controller: "Test",
            action: "GetInterPath",
            method: "post",
            body: JSON.stringify({ courseID: this.props.courseID }),
            success: (result) => {
                if (result.success) {
                    this.setState({ coursePath: result.path })
                }
                this.setState({ loaded: true });
            },
            error: (err) => {
                this.setState({ loaded: true });
                console.log(err);
            }
        })

    }
    getMedia()
    {
        this.setState({ loaded: false })
        this.props.api.send({
            controller: "Course",
            action: "LoadCourseVideoPath",
            method: "post",
            debug: true,
            body: JSON.stringify({ courseID: this.props.courseID}),
            success: (result) => {
                if (result.success) {
                    this.setState({ vidfound: true });
                    this.setState({ loaded: true });
                    this.setState({ videoPath: result.videoPath });
                }
                else {
                    this.setState({ loaded: true });
                }
            },
            error: (err) => {
                this.setState({ loaded: true });
            }
        })
    }
    startTest()
    {
        var message = "Please ensure that you have reviewed the course content and understand the material. ";
        message += "Once you start the test, exiting prematurely will result in unanswered questions being ";
        message += "counted against your garde.  Are you ready to proceed?";
        if (window.confirm(message))
        {
            this.phaseFinished();
        }
    }
    phaseFinished()
    {
        this.setState({loaded: false})
        var attemptID = null;
        if (localStorage.getItem("attemptID") !== null)
        {
            attemptID = localStorage.getItem("attemptID");
        }
        this.props.api.send({
            controller: "Attempt",
            action: "UpdateAttemptStatus",
            method: "post",
            body: JSON.stringify({attemptID: attemptID}),
            success: (result) => {
                this.getAttempt();
            },
            error: (err) => {
                this.setState({loaded: true})
            }
        })
    }
    final()
    {
        this.setState({loaded: false})
        var attemptID = null;
        if (localStorage.getItem("attemptID") !== null)
        {
            attemptID = localStorage.getItem("attemptID");
        }
        this.props.api.send({
            controller: "Attempt",
            action: "UpdateAttemptStatus",
            method: "post",
            body: JSON.stringify({attemptID: attemptID}),
            success: (result) => {
                window.close();
            },
            error: (err) => {
                this.setState({loaded: true})
            }
        })
    }
    renderMedia()
    {
        if (this.state.loaded) {
            if (this.state.attempt) {
                if (this.state.attempt.courseInfo) {
                    if (this.state.attempt.courseInfo.mediaT) {
                        switch (this.state.attempt.courseInfo.mediaT) {
                            case 0:
                                return (
                                    <div className="lmscoursearea">
                                        <h1>{this.state.attempt.courseInfo ? this.state.attempt.courseInfo.courseName : null} - Class</h1>
                                        <h3>Course content is missing for this class.</h3>
                                    </div>
                                )
                            case 1:
                                return (
                                    <div className="lmscoursearea">
                                        <h1>{this.state.attempt.courseInfo ? this.state.attempt.courseInfo.courseName : null} - Class</h1>
                                        <iframe src={
                                            'https://view.officeapps.live.com/op/embed.aspx?src=https://safetycheck.csem.com/courses/' +
                                            this.state.attempt.courseInfo.courseID + "/" + this.state.attempt.courseInfo.courseFile
                                        } width='350px' height='350px' frameBorder='0' title="Course Content" alt="Media for Class" />
                                    </div>
                                )
                            case 2:
                                return (
                                    <div className="lmscoursearea" width="100px" height="100px">
                                        <h1>{this.state.attempt.courseInfo ? this.state.attempt.courseInfo.courseName : null} - Class</h1>
                                        <div id="videoPlayArea">
                                            <video src={
                                                this.state.videoPath
                                            } width='400px' height='400px' frameBorder='0' title="Course Content" alt="Media for Class"
                                                autoPlay={true} controls={true} />
                                        </div>
                                    </div>
                                )
                            case 3:
                                return (
                                    <div>
                                        <h1>{this.state.attempt.courseInfo ? this.state.attempt.courseInfo.courseName : null} - Class</h1>
                                        <div>
                                            <iframe className="interactiveCourseIframe" style={{ height: '70vh' }} src={this.state.coursePath}
                                                frameBorder='0' title="Course Content" alt="Interactive Media for Class">
                                                <label>Cannot access the course. Please use another browser that supports IFrames.</label>
                                            </iframe>
                                        </div>
                                    </div>
                                    )
                            default:
                                return (
                                    <div className="lmscoursearea">
                                        <h1>{this.state.attempt.courseInfo ? this.state.attempt.courseInfo.courseName : null} - Class</h1>
                                        <h3>Course content is missing for this class.</h3>
                                    </div>
                                )
                        }
                    }
                    else {
                        return (
                            <div className="lmscoursearea">
                                <h1>{this.state.attempt.courseInfo ? this.state.attempt.courseInfo.courseName : null} - Class</h1>
                                <h3>Course content is missing for this class.</h3>
                            </div>
                        )
                    }
                }
                else {
                    return (
                        <div className="lmscoursearea">
                            <h1>{this.state.attempt.courseInfo ? this.state.attempt.courseInfo.courseName : null} - Class</h1>
                            <h3>Course content is missing for this class.</h3>
                        </div>
                    )
                }
            }
            else {
                return (
                    <div className="lmscoursearea">
                        <h1>{this.state.attempt.courseInfo ? this.state.attempt.courseInfo.courseName : null} - Class</h1>
                        <h3>Course content is missing for this class.</h3>
                    </div>
                )
            }
        }
    }
    render()
    {
        //const embedppt = this.state.loaded ? 
        //    this.state.attempt.courseInfo ? 
        //        this.state.attempt.courseInfo.courseFile ?
        //            'https://view.officeapps.live.com/op/embed.aspx?src=https://safetycheck.csem.com/courses/' +
        //                this.state.attempt.courseInfo.courseID + "/" + this.state.attempt.courseInfo.courseFile
        //            : null
        //        : null
        //    : null;
        return (
            <div className="lmscourseruntime">
                {this.state.loaded ? 
                    //this.state.attempt.courseInfo.mediaT === 3 ? (
                    //    <div className="lmstestcoursecontainer">
                    //        <div className="lmscoursearea">
                    //            <h1>{this.state.attempt.courseInfo ? this.state.attempt.courseInfo.courseName : null} - Interactive Test</h1>
                    //        </div>
                    //        <TestInter api={this.props.api} courseID={this.props.courseID} testID={this.state.attempt.pretestID} attempt={this.state.attempt} getAttempt={() => this.getAttempt()} />
                    //    </div>
                    //) : (
                        this.state.attempt.courseStatusID === 0 ? (
                            <div className="lmstestcoursecontainer">
                                <div className="lmscoursearea">
                                    <h1>{this.state.attempt.courseInfo ? this.state.attempt.courseInfo.courseName : null} - Pretest</h1>
                                </div>
                                <Test api={this.props.api} courseID={this.props.courseID} testID={this.state.attempt.pretestID} getAttempt={() => this.getAttempt()} />
                            </div>
                        ) : this.state.attempt.courseStatusID === 1 ? (
                            <div className="lmstestcoursecontainer">
                                <div className="lmscoursearea">
                                    <h1>{this.state.attempt.courseInfo ? this.state.attempt.courseInfo.courseName : null} - Pretest Results</h1>
                                </div>
                                <TestResult api={this.props.api} courseID={this.props.courseID} testID={this.state.attempt.pretestID} phaseFinished={this.phaseFinished} pretest={true} />
                            </div>
                        ) : this.state.attempt.courseStatusID === 2 ? (
                            <div className="lmstestcoursecontainer">
                                {this.renderMedia()}
                                <div className="lmstestfooter">
                                    <input className="lmsbutton lmsquestionbutton" type="button" value="Start Test" onClick={this.startTest} />
                                </div>
                            </div>
                        ) : this.state.attempt.courseStatusID === 3 ? (
                            <div className="lmstestcoursecontainer">
                                <div className="lmscoursearea">
                                    <h1>{this.state.attempt.courseInfo ? this.state.attempt.courseInfo.courseName : null} - Test</h1>
                                </div>
                                <Test api={this.props.api} courseID={this.props.courseID} testID={this.state.attempt.posttestID} getAttempt={() => this.getAttempt()} />
                            </div>
                        ) : this.state.attempt.courseStatusID === 4 ? (
                            <div className="lmstestcoursecontainer">
                                <div className="lmscoursearea">
                                    <h1>{this.state.attempt.courseInfo ? this.state.attempt.courseInfo.courseName : null} - Final Test Results</h1>
                                </div>
                                <TestResult api={this.props.api} courseID={this.props.courseID} testID={this.state.attempt.posttestID} 
                                    phaseFinished={this.final} pretest={false} getAttempt={() => this.getAttempt()} />
                            </div>
                        ) : null
                /*)*/ : (
                    <div className="lmscenter">
                        <img src="/images/spinner.svg" className="spinnerbg" alt="Loading..." />
                    </div>
                )}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/course/course.js